// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoMessage_info-message__wL0yN {
  position: relative;
  display: flex;
  width: 100%;
  padding: 8px 8px 8px 12px;
  border: 1px solid #8686ff;
  border-radius: 12px;
  color: #000093;
  background: #fcfcfd;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
}
.InfoMessage_info-message__wL0yN.InfoMessage_success__NjbuA {
  border: 1px solid #126f0e;
  color: #126f0e;
  background: #f4fced;
}
.InfoMessage_info-message__wL0yN.InfoMessage_warning__XmoRr {
  border: 1px solid #fbd298;
  color: #b94402;
  background: #fef9f0;
}
.InfoMessage_info-message__wL0yN.InfoMessage_error__c\\+k37 {
  border: 1px solid #f4ada1;
  color: #911727;
  background: #fdf1ed;
}
.InfoMessage_info-message__wL0yN.InfoMessage_warningrenew__3VHjY {
  border: 1px solid #BDF2A0;
  color: #126f0e;
  background: #BDF2A0;
}

.InfoMessage_suffix__XZOIU {
  margin: 0 0 0 auto;
}

@media screen and (max-width: 900px) {
  .InfoMessage_info-message__wL0yN {
    flex-wrap: wrap;
    padding: 12px;
  }
  .InfoMessage_suffix__XZOIU {
    width: 100%;
    margin-top: 12px;
  }
  .InfoMessage_suffix__XZOIU button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/InfoMessage/InfoMessage.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cCJS;EDKT,mBCES;EDDT,gBAAA;EACA,eAAA;EACA,iBAAA;AAIF;AAFE;EACE,yBAAA;EACA,cCEO;EDDP,mBCDO;ADKX;AADE;EACE,yBAAA;EACA,cCCS;EDAT,mBCHS;ADMb;AAAE;EACE,yBAAA;EACA,cCCM;EDAN,mBCJM;ADMV;AACE;EACE,yBAAA;EACA,cChBO;EDiBP,mBAAA;AACJ;;AAGA;EACE,kBAAA;AAAF;;AAKA;EACE;IACE,eAAA;IACA,aAAA;EAFF;EAKA;IACE,WAAA;IACA,gBAAA;EAHF;EAKE;IACE,WAAA;EAHJ;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.info-message {\n  position: relative;\n  display: flex;\n  width: 100%;\n  padding: 8px 8px 8px 12px;\n  border: 1px solid colors.$primary3;\n  border-radius: 12px;\n  color: colors.$primary7;\n  background: colors.$neutral1;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n\n  &.success {\n    border: 1px solid colors.$success6;\n    color: colors.$success6;\n    background: colors.$success1;\n  }\n\n  &.warning {\n    border: 1px solid colors.$attention3;\n    color: colors.$attention7;\n    background: colors.$attention1;\n  }\n\n  &.error {\n    border: 1px solid colors.$danger3;\n    color: colors.$danger6;\n    background: colors.$danger1;\n  }\n\n  &.warningrenew {\n    border: 1px solid #BDF2A0;\n    color: colors.$success6;\n    background: #BDF2A0;\n  }\n}\n\n.suffix {\n  margin: 0 0 0 auto;\n}\n\n\n\n@media screen and (max-width: sizes.$breakpoint-md) {\n  .info-message {\n    flex-wrap: wrap;\n    padding: 12px;\n  }\n\n  .suffix {\n    width: 100%;\n    margin-top: 12px;\n\n    button{\n      width: 100%;\n    }\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"info-message": `InfoMessage_info-message__wL0yN`,
	"success": `InfoMessage_success__NjbuA`,
	"warning": `InfoMessage_warning__XmoRr`,
	"error": `InfoMessage_error__c+k37`,
	"warningrenew": `InfoMessage_warningrenew__3VHjY`,
	"suffix": `InfoMessage_suffix__XZOIU`
};
export default ___CSS_LOADER_EXPORT___;
